import { useParams } from 'react-router-dom';
import { UnitSettingsPage as SharedUnitSettingsPage } from '@masonic-tools/shared-unit-settings';
import { db, storage, functions } from '@/lib/firebase';
import { useAuth } from '@/contexts/AuthContext';
import { useUnit } from '@/contexts/UnitContext';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Switch } from '@/components/ui/switch';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import Header from '@/components/layout/Header';
import { showSuccess, showError, confirmAction } from '@/lib/swal';
import { formatDate, cn } from '@/lib/utils';
import { VenuesTab } from '@/components/venues/VenuesTab';

export default function UnitSettingsPage() {
  const { unitId } = useParams<{ unitId: string }>();
  const { currentUser, userProfile } = useAuth();
  const { refreshUnits } = useUnit();

  return (
    <SharedUnitSettingsPage
      unitId={unitId}
      currentUser={currentUser}
      userProfile={userProfile}
      db={db}
      storage={storage}
      functions={functions}
      refreshUnits={refreshUnits}
      showSuccess={showSuccess}
      showError={showError}
      confirmAction={confirmAction}
      formatDate={formatDate}
      cn={cn}
      Header={Header}
      Button={Button}
      Input={Input}
      Label={Label}
      Textarea={Textarea}
      Select={Select}
      SelectTrigger={SelectTrigger}
      SelectContent={SelectContent}
      SelectItem={SelectItem}
      SelectValue={SelectValue}
      Card={Card}
      CardContent={CardContent}
      CardDescription={CardDescription}
      CardHeader={CardHeader}
      CardTitle={CardTitle}
      Badge={Badge}
      Switch={Switch}
      Dialog={Dialog}
      DialogContent={DialogContent}
      DialogHeader={DialogHeader}
      DialogTitle={DialogTitle}
      DialogDescription={DialogDescription}
      DialogFooter={DialogFooter}
      VenuesTab={VenuesTab}
    />
  );
}
